import { useCallback, useState } from "react";

type ToggleHookReturn = [boolean, () => void];

export default function useToggle(inicialState?: boolean): ToggleHookReturn {
    const [flag, setFlag] = useState(inicialState ?? false);

    const toggle = useCallback(() => setFlag((current) => !current), []);

    return [flag, toggle];
}
